import styled from 'styled-components'

export const PreviewSkeleton = () => {
  return (
    <>
      <SSkeletonImg />

      <SSkeletonCommentRow>
        <SSkeletonAvatar />

        <SSkeletonComment>
          <SSkeletonAuthorName />

          <SSkeletonCommentText />
        </SSkeletonComment>
      </SSkeletonCommentRow>
    </>
  )
}

const SSkeletonImg = styled.div`
  width: 100%;
  height: 236px;
  background-color: #0000000F;
`

const SSkeletonCommentRow = styled.div`
  margin-top: 36px;
  display: flex;
`

const SSkeletonAvatar = styled.div`
  margin-right: 16px;
  min-width: 32px;
  width: 32px;
  height: 32px;
  background-color: #0000000F;
  border-radius: 50%;
`

const SSkeletonComment = styled.div`
  width: 100%;
`

const SSkeletonAuthorName = styled.div`
  width: 186px;
  height: 16px;
  background-color: #0000000F;
  border-radius: 4px;
`

const SSkeletonCommentText = styled.div`
  margin-top: 8px;
  width: 100%;
  height: 16px;
  background-color: #0000000F;
  border-radius: 4px;
`


